import Api from '../api'
import store from '../store'

export default ({

  state: {
    userLists: [],
    roleLists: [],
    moduleList: [],
    basicAccoduntList: [],
    masterSetupList: []
  },
  mutations: {
    ADD_USER (state, userLists) {
      let userList = state.userLists.concat(userLists)
      state.userLists = userList
    },
    SET_USERS (state, userList) {
      state.userLists = userList
    },
    ADD_ROLE (state, roleLists) {
      let roleList = state.roleLists.concat(roleLists)
      state.roleLists = roleList
    },
    SET_ROLE (state, roleList) {
      state.roleLists = roleList
    },
    DELETE_USER (state, userId) {
      let user = state.userLists.filter(a => a.id !== userId.id)
      state.userLists = user
    },
    DELETE_ROLE (state, roleId) {
      let role = state.roleLists.filter(a => a.id !== roleId.id)
      state.roleLists = role
    },
    UPDATE_USER(state, updatedUser) {
      state.userLists = state.userLists.map(user => user.id !== updatedUser.id ? user : {...user, ...updatedUser})
    },
    UPDATE_ROLE(state, updatedRole) {
      state.roleLists = state.roleLists.map(role => role.id !== updatedRole.id ? role : {...role, ...updatedRole})
      store.commit('MODULES', updatedRole.modules)
    },
    SET_MODULE(state, module) {
      state.moduleList = module
    },
    SET_Master_Setup(state, module) {
      state.masterSetupList = module
    },
    UPDATE_Master_Setup(state, updatedUser) {
      state.masterSetupList = state.masterSetupList.map(masterSetup => masterSetup.id !== updatedUser.id ? masterSetup : {...masterSetup, ...updatedUser})
    },
    DELETE_Master_Setup (state, roleId) {
      let role = state.masterSetupList.filter(a => a.id !== roleId.id)
      state.masterSetupList = role
    },
    ADD_Master_Setup (state, userLists) {
      let userList = state.masterSetupList.concat(userLists)
      state.masterSetupList = userList
    },
    SET_BASICACCOUNT_LIST(state, basicAccounts) {
      state.basicAccountList = basicAccounts
    },
    UPDATE_BASICACCOUNT_SETUP(state, updatedBasicAccount) {
      state.basicAccountList = state.basicAccountList.map(basicAccount => basicAccount.id !== updatedBasicAccount.id ? basicAccount : {...basicAccount, ...updatedBasicAccount})
    }
  },
  actions: {
    async createUser({commit}, user) {
      let response = await Api.request('post', '/users/' + this.state.organisationid + '/' + this.state.user.id, user)
      let savedUser = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_USER', savedUser)
      }
      return response
    },
    async loadUser({commit}) {
      let response = await Api.request('get', '/users/' + this.state.organisationid, null)
      commit('SET_USERS', response.data.data)
      return response
    },
    async loadRiderUser({commit}) {
      let response = await Api.request('get', '/users/riderUserList/' + this.state.organisationid, null)
      commit('SET_USERS', response.data.data)
      return response
    },
    async createRole({commit}, role) {
      let response = await Api.request('post', '/role/' + this.state.organisationid + '/' + this.state.user.id, role)
      let savedRole = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_ROLE', savedRole)
      }
      return response
    },
    async updateRole({commit}, role) {
      let response = await Api.request('put', '/role/' + this.getters.organisationId + '/' + role.id, role)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_ROLE', response.data.data)
      }
      return response
    },
    async loadRole({commit}) {
      let response = await Api.request('get', '/role/' + this.state.organisationid, null)
      commit('SET_ROLE', response.data.data)
    },
    async deleteUser({commit}, user) {
      let response = await Api.request('delete', '/users/' + user.userId + '/' + this.state.user.id + '/' + user.deleteReason)
      let userLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_USER', userLists)
      }
      return response
    },
    async deleteRole({commit}, role) {
      let response = await Api.request('delete', '/role/' + role.roleId + '/' + this.state.user.id + '/' + role.deleteReason)
      let roleLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_ROLE', roleLists)
      }
      return response
    },
    async updateUser({commit}, user) {
      let response = await Api.request('put', '/users/' + user.userId + '/' + this.state.user.id, user)
      commit('UPDATE_USER', response.data.data)
      return response
    },
    async updatePassword({commit}, passwordDetail) {
      let response = await Api.request('put', '/users/resetPassword/' + this.state.user.id, passwordDetail)
      return response
    },
    async moduleList({commit}) {
      let response = await Api.request('get', '/role/moduleList/' + this.state.organisationid)
      commit('SET_MODULE', response.data.data)
      return response
    },
    async createMasterSetup({ commit }, masterSetup) {
      let response = await Api.request('post', '/masterSetup/createMasterSetup/' + this.state.user.id + '/' + this.state.organisationid + '', masterSetup)
      let masterSetup1 = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_Master_Setup', masterSetup1)
      }
      return response
    },
    async updateMasterSetup({ commit }, masterSetup) {
      let resp = await Api.request('put', '/masterSetup/updateMasterSetup/' + masterSetup.id + '/' + this.state.organisationid + '/' + this.state.user.id + '', masterSetup)
      commit('UPDATE_Master_Setup', resp.data.data)
      return resp
    },
    async deleteMasterSetup({ commit }, masterSetup) {
      let resp = await Api.request('delete', '/masterSetup/deleteMasterSetup/' + masterSetup.id + '/' + this.state.user.id + '/' + masterSetup.deleteReason + '/' + this.state.organisationid)
      let masterSetup1 = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_Master_Setup', masterSetup1)
      }
      return resp
    },
    async loadMasterSetupList({ commit }, type) {
      let response = await Api.request('get', '/masterSetup/masterSetupListByType/' + this.state.organisationid + '/' + type, null)
      commit('SET_Master_Setup', response.data.data)
      return response
    },
    async sendInquiry({commit}, inquiryData) {
      let response = await Api.request('post', '/inquiry/saveinquiry', inquiryData)
      return response
    },
    async loadDailyTransactionSummary({commit}) {
      let response = await Api.request('get', '/dashboard/dailyTransactionSummary/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.nepaliNewDate)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadDeliverySummary({commit}, date) {
      let response = await Api.request('get', '/dashboard/deliverySummary/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.warehouse)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadDailyCashSummary({commit}) {
      let response = await Api.request('get', '/dashboard/dailyCashSummary/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.nepaliNewDate)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async basicAccountSetupList({commit}) {
      let response = await Api.request('get', '/basicAccount/' + this.state.organisationid)
      commit('SET_BASICACCOUNT_LIST', response.data.data)
      return response
    },
    async updateBasicAccountSetUp({commit}, data) {
      let response = await Api.request('put', '/basicAccount/' + data.id + '/' + data.accountMasterId)
      commit('UPDATE_BASICACCOUNT_SETUP', response.data.data)
      return response
    },
    async loadPurchaseBar({commit}) {
      let response = await Api.request('get', '/dashboard/reportByPurchaseMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'purchase')
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    },
    async loadSalesBar({commit}) {
      let response = await Api.request('get', '/dashboard/reportByPurchaseMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'sales')
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    },
    async loadWeekSalesBar({ commit }, { month }) {
      const url = `/dashboard/reportBySalesWeeklyPie/${this.state.organisationid}/${this.state.fyId}?monthName=${month}`
      try {
        let response = await Api.request('get', url)
        if (response.data.status === 'SUCCESS') {
          return response.data.data[0]
        }
      } catch (error) {
        console.error('Error fetching weekly sales data:', error)
        return null
      }
    },
    async loadWeeklyTargetAchievedBar({ commit }, { month }) {
      const url = `/dashboard/reportByTargetAchievedWeeklyPie/${this.state.organisationid}/${this.state.fyId}?monthName=${month}`
      try {
        let response = await Api.request('get', url)
        if (response.data.status === 'SUCCESS') {
          return response.data.data[0]
        }
      } catch (error) {
        console.error('Error fetching weekly target sales data:', error)
        return null
      }
    },
    async loadDailyTargetAchievedBar({ commit }, { month }) {
      const url = `/dashboard/reportByTargetAchievedDailyPie/${this.state.organisationid}/${this.state.fyId}?monthName=${month}`
      try {
        let response = await Api.request('get', url)
        if (response.data.status === 'SUCCESS') {
          return response.data.data
        }
      } catch (error) {
        console.error('Error fetching daily sales data:', error)
        return null
      }
    },
    async loadCashInBar({commit}) {
      let response = await Api.request('get', '/dashboard/reportByCashInCashOutMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'in')
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    },
    async loadCashInOutBar({commit}) {
      let response = await Api.request('get', '/dashboard/reportByCashInCashOutMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'all')
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    },
    async loadCashOutBar({commit}) {
      let response = await Api.request('get', '/dashboard/reportByCashInCashOutMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'out')
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    },
    // async loadCashOutBar({commit}) {
    //   let response = await Api.request('get', '/dashboard/reportByCashInCashOutMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'out')
    //   if (response.data.status === 'SUCCESS') {
    //     return response.data.data[0]
    //   }
    // },
    async loadProfitLossMonthly({commit}) {
      let response = await Api.request('get', '/dashboard/reportByProfitAndLossMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'out')
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    },
    async loadPurchaseSalesBar({ commit }) {
      let response = await Api.request('get', '/dashboard/reportByPurchaseMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'all')
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    },
    async loadCustomerWiseSalesCountGraph({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/customerWiseSalesCountGraph/' + this.state.user.id + '/' + this.state.organisationid + '/' + date.fromDate + '/' + date.toDate + '')
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    },
    async loadUserWiseSalesCountGraph({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/userWiseSalesCountGraph/' + this.state.user.id + '/' + this.state.organisationid + '/' + date.fromDate + '/' + date.toDate + '')
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    },
    async loadGrossMarginGraph({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/grossMarginSalesGraph/' + this.state.user.id + '/' + this.state.organisationid + '/' + date.fromDate + '/' + date.toDate + '')
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    },
    async loadTargetAchievementBar({ commit }) {
      let response = await Api.request('get', '/inventoryOut/reportByTargetAchievementMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId)
      if (response.data.status === 'SUCCESS') {
        return response.data.data[0]
      }
    }
  },
  getters: {
    masterSetupByType: (state) => (type) => {
      return state.masterSetupList.filter(item => item.setupType === type)
    },
    masterSetupByTypeAndName: (state) => (type, name) => {
      return state.masterSetupList.filter(item =>
        item.setupType === type && item.name === name
      )
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/user.js